import { API_ENDPOINTS, api } from "../apis/constants";
import { cacheService } from "./cache.service";

export interface Category {
    _id: string;
    name: string;
    description?: string;
    slug: string;
}

interface GetCategoriesOptions {
    forceFresh?: boolean;
    cacheTTL?: number;
}

class CategoryService {
    private CACHE_KEY = 'categories_data';

    /**
     * Fetch all public categories
     * @returns Promise<Category[]>
     */
    async getPublicCategories(options: GetCategoriesOptions = {}): Promise<Category[]> {
        return cacheService.get<Category[]>(
            this.CACHE_KEY,
            async () => {
                try {
                    const response = await api.get<Category[]>(API_ENDPOINTS.CATEGORIES.PUBLIC);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching categories:', error);
                    throw error;
                }
            },
            {
                forceFresh: options.forceFresh,
                ttl: options.cacheTTL || 300 // Cache for 5 minutes by default
            }
        );
    }
}

export const categoryService = new CategoryService(); 